import React from 'react';

const KeySingleFeature = ({ icon, title, content }) => {
    return (
        <>
            <div className="features__key__item">
                <div className="features__key__item__content">
                    <div className="features__key__icon">
                        <i> {icon} </i>
                    </div>
                    <h3>{title}</h3>
                    <p>{content}</p>
                </div>
            </div>
        </>
    );
};

export default KeySingleFeature;
